import { heaterFootprint, type InteriorLayout } from "../domain/interior/types";
import {
	deriveInteriorLayoutContext,
	type InteriorLayoutContext,
	resolveInteriorLayout,
} from "./interiorLayoutResolver";
import type { FlueAxisM } from "./squareBaseBuilder/context";
import type { BuildInput } from "./types";

/**
 * Plan position of a wood stove's flue: the centre of the heater the layout
 * stands — the same footprint `createInteriorRenderPlan` puts the drawn stove
 * and its chimney on. The roof's skorstensväxling, the BOM's trimmer rows and
 * the dirty tracker all read the flue through here.
 */
export function flueAxisFromLayout(
	layout: InteriorLayout,
	context: InteriorLayoutContext,
): FlueAxisM {
	const box = heaterFootprint(layout.heater, context.room, context.heaterSize);
	return {
		x: (box.minXMm + box.maxXMm) / 2000,
		z: (box.minZMm + box.maxZMm) / 2000,
	};
}

/**
 * The flue for a build input, or null without a wood stove (or an interior).
 * Two-room inputs must arrive with their config materialised, as the registry
 * hands them to the resolver (`resolveTwoRoomConfig`).
 */
export function resolveFlueAxisM(input: BuildInput): FlueAxisM | null {
	if (input.thermalInputs?.heaterType !== "wood") return null;
	const context = deriveInteriorLayoutContext(input);
	const layout = context ? resolveInteriorLayout(input, context) : null;
	return context && layout ? flueAxisFromLayout(layout, context) : null;
}
